import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@/components/Modal';

import { ROLE, fetchResetFeathers } from '@/modules/User';

import { Flex, Box } from 'UIKit/Grid';
import { SimpleButton, StyledButton, StyledButtonLink } from 'UIKit/Form';

import AvatarDefault from '@/assets/img/AvatarDefault.png';

import Bage1 from '@/assets/img/bages/1.png';
import Bage2 from '@/assets/img/bages/2.png';
import Bage3 from '@/assets/img/bages/3.png';
import Bage4 from '@/assets/img/bages/4.png';
import Bage5 from '@/assets/img/bages/5.png';
import Bage6 from '@/assets/img/bages/6.png';
import Bage7 from '@/assets/img/bages/7.png';
import Bage8 from '@/assets/img/bages/8.png';
import Bage9 from '@/assets/img/bages/9.png';
import Bage10 from '@/assets/img/bages/10.png';

const ranks = [
  {
    rank: 'RANK_1',
    bage: Bage1,
    progressColor: 0,
    next: 100,
  },
  {
    rank: 'RANK_2',
    bage: Bage2,
    progressColor: 0,
    next: 500,
  },
  {
    rank: 'RANK_3',
    bage: Bage3,
    progressColor: 0,
    next: 1000,
  },
  {
    rank: 'RANK_4',
    bage: Bage4,
    progressColor: 1,
    next: 1500,
  },
  {
    rank: 'RANK_5',
    bage: Bage5,
    progressColor: 1,
    next: 2500,
  },
  {
    rank: 'RANK_6',
    bage: Bage6,
    progressColor: 1,
    next: 3500,
  },
  {
    rank: 'RANK_7',
    bage: Bage7,
    progressColor: 2,
    next: 5000,
  },
  {
    rank: 'RANK_8',
    bage: Bage8,
    progressColor: 2,
    next: 6500,
  },
  {
    rank: 'RANK_9',
    bage: Bage9,
    progressColor: 2,
    next: 8000,
  },
  {
    rank: 'RANK_10',
    bage: Bage10,
    progressColor: 3,
  },
];

const calculateRank = exp => {
  let res = null;
  for (let i = 0; i < ranks.length; i += 1) {
    if (ranks[i].next == null || ranks[i].next > exp) {
      res = ranks[i];
      break;
    }
  }
  return res;
};

export const NewRankModal = ({ show, experiences }) => {
  const [newRankModalOpen, setNewRankModalOpen] = useState(show);
  const [rank, setRank] = useState('RANK_1');
  const [bage, setBage] = useState(Bage1);

  useEffect(() => {
    const res = calculateRank(experiences);
    setRank(res.rank);
    setBage(res.bage);
  }, [experiences]);

  const closeModalHandler = () => {
    setNewRankModalOpen(false);
  };
  return (
    <>
      <Modal
        show={newRankModalOpen}
        close={() => {
          setNewRankModalOpen(false);
        }}
      >
        <Flex flexDirection="column" alignItems="center">
          <Box style={{ fontSize: '18px' }}>
            Поздравляем с получением нового звания:
          </Box>
          <Box style={{ fontSize: '20px', fontWeight: 'bold' }} mb={12}>
            <FormattedMessage id={rank} defaultMessage="" />
          </Box>
          <Box style={{ fontSize: '18px' }} mb={4}>
            Теперь у тебя новая рамка:
          </Box>
          <Box mb={4}>
            <img src={bage} alt="" />
          </Box>
          <StyledButton onClick={closeModalHandler}>Отлично!</StyledButton>
        </Flex>
      </Modal>
    </>
  );
};

NewRankModal.propTypes = {
  experiences: PropTypes.number.isRequired,
  show: PropTypes.any.isRequired,
};

const mapStateToProps = state => ({
  experiences: state.user.experiences,
  // requests: state.requests,
});

export const NewRankModalComponent = connect(mapStateToProps)(NewRankModal);

const infoStyles = makeStyles(() => ({
  column: {
    maxWidth: '486px',
    fontFamily: 'Montserrat, sans-serif',
  },
  paramsWrap: {
    margin: '30px',
    '& > *': {
      marginBottom: '16px',
    },
  },
  paramsRankButton: {
    '&:hover': {
      '& > *': {
        color: '#569887',
      },
    },
  },
  paramName: {
    fontSize: '18px',
    color: '#252733',
  },
  paramValue: {
    fontSize: '24px',
    fontWeight: 'bold',
    color: '#252733',
  },
  avatarWrap: { margin: '30px', position: 'relative' },
  avatar: {
    width: '150px',
    height: '150px',
    backgroundColor: '#fff',
  },
  avatarBage: {
    position: 'absolute',
    left: '-23px',
    top: '121px',
    minWidth: '195px',
  },
  progressWrap: {},
  progressTitle: {
    fontSize: '14px',
    marginBottom: '12px',
  },
  progressIndicatorWrap: {
    height: '36px',
    borderRadius: '10px',
    background:
      'linear-gradient(270deg, rgba(41, 10, 89, 0.4) 0%, rgba(255, 124, 0, 0.4) 100%)',
    padding: '1px',
  },
  progressIndicatorContainer: {
    background: '#fff',
    height: '100%',
    borderRadius: '10px',
    padding: '1px',
    position: 'relative',
  },
  progressIndicator: {
    background: 'linear-gradient(270deg, #1A9C1C 0%, #025A17 100%)',
    borderRadius: '8px',
    height: '100%',
    '&[type="1"]': {
      background: 'linear-gradient(270deg, #D363F1 0%, #8001AA 100%)',
    },
    '&[type="2"]': {
      background: 'linear-gradient(270deg, #C8731E 0%, #FEDD7F 100%)',
    },
    '&[type="3"]': {
      background: 'linear-gradient(270deg, #004A70 0%, #00C0FF 100%)',
    },
  },
  progressLabel: {
    color: '#000',
    fontSize: '11px',
    fontWeight: 'bold',
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
    height: '100%',
    width: '100%',
    paddingRight: '10px',
  },

  rankWrap: {
    marginTop: '20px',
    borderRadius: '10px',
    background:
      'linear-gradient(270deg, rgba(41, 10, 89, 0.4) 0%, rgba(255, 124, 0, 0.4) 100%)',
    padding: '1px',
    boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
    width: '100%',
  },
  rankContainer: {
    background: '#fff',
    height: '100%',
    borderRadius: '10px',
    maxHeight: '300px',
    overflow: 'auto',
  },
  rankHead: {},
  row4head: {
    display: 'flex',
    fontSize: '12px',
    borderBottom: '1.5px solid #DFE0EB',
    '& > *': {
      width: '25%',
      padding: '20px',
    },
  },
  row4body: {
    display: 'flex',
    fontSize: '12px',
    borderBottom: '1.5px solid #DFE0EB',
    '& > *': {
      width: '25%',
      padding: '20px',
    },
    '&:last-child': {
      borderBottom: '0',
    },
  },
  rowSelected: {
    fontWeight: 'bold',
  },
}));

const PanelInfo = ({ user, rating, deviceWidth, resetFeathers }) => {
  const classes = infoStyles();
  const avatar = user.photo && user.photo.url ? user.photo.url : '';
  const [rank, setRank] = useState('RANK_1');
  const [bage, setBage] = useState(Bage1);
  const [progressColor, setProgressColor] = useState(0);
  const [nextScore, setNextScore] = useState(null);

  const [modalShow, setModalShow] = useState(false);
  const [resetModalShow, setResetModalShow] = useState(false);

  useEffect(() => {
    // Обновляем заголовок документа с помощью API браузера
    const res = calculateRank(user.experiences || 0);
    setRank(res.rank);
    setBage(res.bage);
    setProgressColor(res.progressColor);
    setNextScore(res.next);
  });

  const getCount = () => {
    if (user.role === ROLE.TEACHER || user.role === ROLE.SCHOOL) {
      return rating.moreItems ? rating.moreItems.length : 0;
    }
    return rating.count;
  };

  const handleReset = () => {
    resetFeathers();
    setResetModalShow(false);
  };

  return (
    <>
      <Flex
        flexWrap="nowrap"
        flexDirection={(deviceWidth < 1450 && 'column') || 'row'}
        alignItems="center"
      >
        <div className={classes.avatarWrap}>
          <Avatar src={avatar} alt="avatar" className={classes.avatar}>
            <img src={AvatarDefault} alt="avatar" />
          </Avatar>
          {user.role === ROLE.LEARNER && (
            <img src={bage} alt="avatar" className={classes.avatarBage} />
          )}
        </div>
        <div className={classes.paramsWrap}>
          {user.role === ROLE.LEARNER && (
            <SimpleButton
              className={classes.paramsRankButton}
              onClick={() => setModalShow(true)}
            >
              <div className={classes.paramName}>
                <FormattedMessage id="RANK" defaultMessage="" />
              </div>
              <div className={classes.paramValue}>
                <FormattedMessage id={rank} defaultMessage="" />
              </div>
            </SimpleButton>
          )}

          <div>
            <div className={classes.paramName}>
              <FormattedMessage id="PLACE_IN_RATING" defaultMessage="" />
            </div>

            <div className={classes.paramValue}>
              {user.rank > 0 ? (
                <>
                  {user.rank} <FormattedMessage id="of" defaultMessage="" />{' '}
                  {getCount()}
                </>
              ) : (
                <>
                  <FormattedMessage id="NO_RATE" defaultMessage="" />
                </>
              )}
            </div>
          </div>
          {user.role === ROLE.LEARNER && (
            <div>
              <div className={classes.paramName}>
                <FormattedMessage id="FEATHERS" defaultMessage="" />
              </div>
              <div className={classes.paramValue}>{user.feathers || 0}</div>
            </div>
          )}
          {user.role === ROLE.LEARNER && (
            <div>
              <div className={classes.paramName}>
                <FormattedMessage id="STARS" defaultMessage="" />
              </div>
              <div className={classes.paramValue}>{user.stars || 0}</div>
            </div>
          )}
          {user.role === ROLE.TEACHER && (
            <div>
              <div className={classes.paramName}>
                <FormattedMessage id="UCOINS_TITLE" defaultMessage="" />
              </div>
              <div className={classes.paramValue}>{user.ucoins || 0}</div>
            </div>
          )}
        </div>
      </Flex>
      {user.role === ROLE.ADMIN && (
        <Box mt={5}>
          <FormattedMessage id="FOR_RESET_FEATHERS" defaultMessage="" />
          <Flex mt={4}>
            <StyledButton onClick={() => setResetModalShow(true)}>
              <FormattedMessage id="RESET_FEATHERS" defaultMessage="" />
            </StyledButton>
          </Flex>
        </Box>
      )}
      {user.role === ROLE.LEARNER && (
        <div className={classes.progressWrap}>
          <div className={classes.progressTitle}>
            <FormattedMessage id="PROGRESS_TO_NEXT_RANK" defaultMessage="" />
          </div>
          <div className={classes.progressIndicatorWrap}>
            <div className={classes.progressIndicatorContainer}>
              <div
                className={classes.progressIndicator}
                style={{
                  width: `${(nextScore != null
                    ? (user.experiences || 0) / nextScore
                    : 1) * 100}%`,
                }}
                type={progressColor}
              >
                <div className={classes.progressLabel}>
                  {user.experiences || 0}
                  {nextScore != null
                    ? `/${nextScore} (${Math.round(
                        ((user.experiences || 0) / nextScore) * 100
                      )}
                  %)`
                    : ` (100%)`}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal show={modalShow} close={() => setModalShow(false)}>
        <Flex flexDirection="column" alignItems="center">
          <Box style={{ fontSize: '18px', textAlign: 'center' }} mb={5}>
            <FormattedMessage id="CURRENT_RANK" />{' '}
            <span style={{ fontWeight: 'bold' }}>
              <FormattedMessage id={rank} defaultMessage="" />
            </span>
            <Box mt={5}>
              <FormattedMessage
                id="FOR_RECEIVE_NEW_ACHIEVEMENTS"
                defaultMessage=""
              />
            </Box>
          </Box>
          <div className={classes.rankWrap}>
            <div className={classes.rankContainer}>
              <div className={classes.ratingHead}>
                <div className={classes.row4head}>
                  <div>
                    <FormattedMessage id="LEVEL" defaultMessage="" />
                  </div>
                  <div>
                    <FormattedMessage id="RANK" defaultMessage="" />
                  </div>
                  <div>
                    <FormattedMessage
                      id="EXPERIENCE_GRADING"
                      defaultMessage=""
                    />
                  </div>
                  <div>
                    <FormattedMessage
                      id="EXPERIENCE_REQUIRED"
                      defaultMessage=""
                    />
                  </div>
                </div>
              </div>
              <div>
                {ranks.map((item, i) => (
                  <div
                    className={`${classes.row4body} ${ranks[i].rank === rank &&
                      classes.rowSelected}`}
                    key={item.rank}
                  >
                    <div>{i + 1}</div>
                    <div>
                      <FormattedMessage id={ranks[i].rank} defaultMessage="" />
                    </div>
                    <div>
                      {ranks[i - 1] ? ranks[i - 1].next : 0}-{item.next}
                    </div>
                    <div>
                      {item.next &&
                        +item.next - (ranks[i - 1] ? ranks[i - 1].next : 0)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Flex mt={9}>
            <StyledButton mr={6} onClick={() => setModalShow(false)}>
              <FormattedMessage id="CLEAR" defaultMessage="" />
            </StyledButton>
            <StyledButtonLink to="/about-gamification">
              <FormattedMessage id="ABOUT_GAMIFICATION" defaultMessage="" />
            </StyledButtonLink>
          </Flex>
        </Flex>
      </Modal>

      <Modal show={resetModalShow} close={() => setResetModalShow(false)}>
        <Flex flexDirection="column" alignItems="center" gridGap={10}>
          <Box w={1}>
            <FormattedMessage id="CONFIRM_RESET_FEATHERS" defaultMessage="" />
          </Box>
          <Flex>
            <StyledButton mr={6} onClick={() => setResetModalShow(false)}>
              <FormattedMessage id="CANCEL" defaultMessage="" />
            </StyledButton>
            <StyledButton onClick={handleReset}>
              <FormattedMessage id="OK" defaultMessage="" />
            </StyledButton>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};

const mapStateToPropsPanelInfo = state => ({
  deviceWidth: state.device.width,
});

const mapDispatchToProps = dispatch => ({
  resetFeathers() {
    dispatch(fetchResetFeathers());
  },
});

PanelInfo.propTypes = {
  user: PropTypes.object.isRequired,
  rating: PropTypes.object.isRequired,
  deviceWidth: PropTypes.number.isRequired,
  resetFeathers: PropTypes.func.isRequired,
};

export default connect(
  mapStateToPropsPanelInfo,
  mapDispatchToProps
)(injectIntl(PanelInfo));
